<template>
    <div>
        <pagamento :pagamento="pagamento">
            <template slot="footer">
                <app-btn-voltar></app-btn-voltar>
            </template>
        </pagamento>
        <pagamento-comprometimentos
            :comprometimentos="comprometimentosDisponiveis"
            :pagamentosServicos="pagamentosServicos"
            :incluirSelecao="true"
            titulo="SERVIÇOS DISPONÍVEIS"
        >
            <template slot="selecao" slot-scope="data">
                <b-form-checkbox
                    :value="data.idComprometimento"
                    v-model="comprometimentosDisponiveisSelecionados"
                ></b-form-checkbox>
            </template>
            <template slot="botoes">
                <b-button-group class="float-right">
                    <b-button
                        variant="primary"
                        @click="confirmaAssociarSelecionadas()"
                        :disabled="
                            comprometimentosDisponiveisSelecionados.length === 0
                        "
                        ><i class="fa fa-plus"></i> Associar
                        selecionados</b-button
                    >
                </b-button-group>
            </template>
        </pagamento-comprometimentos>
    </div>
</template>

<script>
import Pagamento from './PagamentoDetalhar'
import PagamentoComprometimentos from './PagamentoComprometimentos'

export default {
    props: {
        pagamentosServicos: {
            type: Object,
            default: () => ({})
        },

        pagamento: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            comprometimentosDisponiveisSelecionados: [],
            comprometimentosDisponiveis: []
        }
    },

    methods: {
        voltar() {
            this.$router.go(-1)
        },

        obterComprometimentosDisponiveis() {
            this.$store.dispatch('addRequest')
            this.pagamentosServicos
                .obterComprometimentosDisponiveis(
                    this.$route.params.pagamentoId
                )
                .then((response) => {
                    if (response) {
                        if (response.success) {
                            this.comprometimentosDisponiveis = response.data
                        } else {
                            this.$toast.error(
                                response.errors,
                                'ERROR',
                                this.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        },

        confirmaAssociarSelecionadas() {
            this.$swal({
                title: 'Associação de Serviços',
                html: `Confirma a associação dos serviços selecionados?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then((result) => {
                if (result.value) {
                    this.associar()
                }
            })
        },

        associar() {
            this.$store.dispatch('addRequest')
            this.pagamentosServicos
                .associarComprometimentos({
                    pagamentoId: this.$route.params.pagamentoId,
                    idsComprometimentos:
                        this.comprometimentosDisponiveisSelecionados
                })
                .then((response) => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Registro salvo com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.$emit('obterPagamentoAtualizado')
                            this.voltar()
                        } else {
                            this.$toast.error(
                                response.errors,
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        }
    },

    created() {
        this.obterComprometimentosDisponiveis()
    },

    components: {
        Pagamento,
        PagamentoComprometimentos
    }
}
</script>
